import React, { useEffect, useState } from "react";
import { Modal } from "@mui/material";
import { toast } from "react-toastify";
import { axiosGetApi } from "../../../helpers/interceptorServices";
import { apiList } from "../../../helpers/apiList";
import CustomAlert from "../../../helpers/CustomAlert";

export default function DeliveryBoyModal({
  open,
  onClose,
  onSubmit,
  hubLoading,
}) {
  const loggedInUserName = sessionStorage.getItem("username");

  const [data, setData] = useState([]);
  const [selectedBoy, setSelectedBoy] = useState("");
  const [loading, setLoading] = useState(false);

  // ✅ Fetch delivery boy list
  const fetchDeliveryBoyData = async () => {
    try {
      setLoading(true);
      const response = await axiosGetApi(
        `${apiList.FETCH_ALL_DELIVERY_BOY_DATA}?username=${loggedInUserName}`
      );

      if (
        response?.status === 200 &&
        response?.data?.status === true &&
        response?.data?.respCode === "00"
      ) {
        setData(response?.data?.data || []);
      } else {
        setData([]);
        toast.warn("No delivery boys found.");
      }
    } catch (error) {
      console.error("Error fetching delivery boy data:", error);
      setData([]);
      CustomAlert({
        title: "Error",
        text: "Failed to fetch delivery boys. Please try again later.",
        icon: "error",
        confirmButtonText: "OK",
      });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (open) fetchDeliveryBoyData();
  }, [open]);

  // ✅ Handle Submit
  const handleSubmit = () => {
    if (!selectedBoy) {
      toast.error("Please select a delivery boy");
      return;
    }

    const selected = data.find((boy) => boy.mobileNo === selectedBoy);
    if (!selected) {
      toast.error("Invalid selection");
      return;
    }
    onSubmit(selected);
  };

  return (
    <Modal open={open} onClose={onClose}>
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 bg-white p-6 rounded-xl shadow-lg w-[380px]">
        <h3 className="text-lg font-semibold text-center mb-5 text-gray-800">
          Select Delivery Boy
        </h3>

        {/* Dropdown */}
        <div className="mb-6">
          <label className="block text-gray-700 text-sm font-medium mb-2">
            Delivery Boy
          </label>
          <select
            value={selectedBoy}
            onChange={(e) => setSelectedBoy(e.target.value)}
            className="w-full border border-gray-300 rounded-lg px-3 py-2 text-gray-700 focus:outline-none focus:ring-2 focus:ring-orange-400 transition-all"
          >
            <option value="">-- Select Delivery Boy --</option>
            {data
              .filter((boy) => boy.status === "ACTIVE")
              .map((boy) => (
                <option key={boy.id} value={boy.mobileNo}>
                  {boy.fullName}
                </option>
              ))}
          </select>
        </div>

        {/* Footer Buttons */}
        <div className="flex justify-center gap-4 border-t pt-4">
          <button
            type="button"
            onClick={onClose}
            className="btn btn-back w-[130px] !rounded-lg bg-gray-200 text-gray-700 hover:bg-gray-300 transition"
          >
            Cancel
          </button>

          <button
            type="button"
            onClick={handleSubmit}
            disabled={hubLoading}
            className="btn btn-submit w-[130px] !rounded-lg"
          >
            {hubLoading ? "Submitting..." : "Submit"}
          </button>
        </div>
      </div>
    </Modal>
  );
}
